export default __webpack_public_path__ + "static/media/H1007.2.ed8c647c.mp3";